import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

export const submitVendorNomination = async (payload) => {
  try {
    return await axiosInstance.post(API_ENDPOINTS.VENDOR_NOMINATIONS, payload);
  } catch (error) {
    throw error; // centralized interceptor will normalize error message
  }
};

export default {
  submitVendorNomination,
};

